export default {
  actualValue: 'Aktueller Wert',
};
